export const LANGUAGE_LOCALES = {
  es: 'es-ES',
  en: 'en-GB',
  fr: 'fr-FR',
  pt: 'pt-PT',
  de: 'de-DE',
};

export const getLocaleFromLang = (lang) => LANGUAGE_LOCALES[lang] || LANGUAGE_LOCALES.en;

export const getLanguageFallbackChain = (lang) => {
  const normalized = lang || 'en';
  const chain = [normalized];
  if (!chain.includes('en')) chain.push('en');
  if (!chain.includes('es')) chain.push('es');
  return chain;
};

const getFieldVariant = (baseField, locale) => {
  if (!baseField) return null;
  if (locale === 'es') return `${baseField}_es`;
  if (locale === 'en') return baseField;
  return `${baseField}_${locale}`;
};

export const getLocalizedField = (entity, baseField, lang, fallback = '') => {
  if (!entity || !baseField) return fallback;

  for (const locale of getLanguageFallbackChain(lang)) {
    const variant = getFieldVariant(baseField, locale);
    const value = variant ? entity?.[variant] : undefined;
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (value !== undefined && value !== null && value !== '') return value;
  }

  const localizedMap = entity?.[`${baseField}_localized`] || entity?.[baseField]?.localized;
  if (localizedMap && typeof localizedMap === 'object') {
    for (const locale of getLanguageFallbackChain(lang)) {
      const value = localizedMap[locale];
      if (typeof value === 'string' && value.trim()) return value.trim();
      if (value !== undefined && value !== null && value !== '') return value;
    }
  }

  return fallback;
};

export const getLocalizedLabel = (entity, lang, fallback = '') => {
  if (!entity) return fallback;
  return (
    getLocalizedField(entity, 'label', lang) ||
    getLocalizedField(entity, 'name', lang) ||
    fallback
  );
};

export const interpolate = (template, values = {}) => {
  if (typeof template !== 'string') return template;
  return Object.entries(values).reduce(
    (result, [key, value]) => result.replaceAll(`{${key}}`, String(value ?? '')),
    template,
  );
};

export const pickLocalizedText = (lang, es, en, extras = {}) => {
  const candidates = { es, en, ...extras };
  for (const locale of getLanguageFallbackChain(lang)) {
    const value = candidates[locale];
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return en || es || '';
};

export const createTextPicker = (lang) => (es, en, extras = {}) =>
  pickLocalizedText(lang, es, en, extras);
